import { render, staticRenderFns } from "./EventListingContainer.vue?vue&type=template&id=2bf338a5"
import script from "./EventListingContainer.vue?vue&type=script&lang=js"
export * from "./EventListingContainer.vue?vue&type=script&lang=js"
import style0 from "./EventListingContainer.vue?vue&type=style&index=0&id=2bf338a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports